import { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Info } from 'lucide-react';

export function DeleteAccount() {
  const [understood, setUnderstood] = useState(false);

  return (
    <div style={{ flexGrow: 1 }}>
      <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem', color: '#dc3545' }}>Delete Account</h2>

      <Alert 
        style={{ 
          display: 'flex', 
          marginBottom: '1rem', 
          backgroundColor: '#f8f9fa', 
          border: '1px solid #dee2e6', 
          padding: '1rem' 
        }}
      >
        <div style={{ 
          backgroundColor: '#fd7e14', 
          padding: '0.5rem', 
          borderRadius: '0.25rem', 
          marginRight: '1rem' 
        }}>
          <Info style={{ color: 'white' }} size={24} />
        </div>
        <div style={{ flexGrow: 1 }}>
          Deleting your account will delete all of the content you have created. It will be completely irrecoverable.
        </div>
      </Alert>

      <Form>
        <Form.Check
          type="checkbox"
          id="understand-consequences"
          style={{ marginBottom: '1rem' }}
          label={<span style={{ color: '#495057' }}>I understand the consequences.</span>}
          checked={understood}
          onChange={(e) => setUnderstood(e.target.checked)}
        />

        <Button 
          style={{ 
            backgroundColor: '#0d6efd', 
            borderColor: '#0d6efd', 
            padding: '0.75rem 1.5rem', 
            fontSize: '1rem', 
            borderRadius: '0.5rem', 
            opacity: understood ? 1 : 0.65
          }}
          disabled={!understood}
        >
          Delete Account
        </Button>
      </Form>
    </div>
  );
}
